// extracted by mini-css-extract-plugin
export default {"tip":"tip-TlZj"};